import { getApiErrorCode } from './apiErrorCode';

const ERROR_KEYS = {
  MoloniNotConnected: 'moloni.errors.notConnected',
  MoloniInvoiceDataMissing: 'moloni.errors.missingData',
  MoloniRejected: 'moloni.errors.rejected',
  InvalidVatNumber: 'moloni.errors.invalidVat',
};

const readText = (data, key) => {
  if (!data || typeof data !== 'object') return '';
  const value = data[key] ?? data[key.charAt(0).toUpperCase() + key.slice(1)];
  return typeof value === 'string' ? value.trim() : '';
};

export const describeInvoiceError = (error, t) => {
  const data = error?.response?.data;
  const details = readText(data, 'details');
  const code = getApiErrorCode(error);
  const key = ERROR_KEYS[code];

  if (code === 'MoloniRejected' && details) {
    if (details.toLowerCase().includes('tax authority')) return t('moloni.errors.seriesNotRegistered');
    return `${t('moloni.errors.rejected')} ${details}`;
  }

  if (key) return t(key);
  if (details) return details;

  const description = readText(data, 'description');
  if (description) return description;

  const message = readText(data, 'message');
  if (message) return message;

  return t('moloni.errors.failed');
};
